"use client";

import PricingContent from "@/components/pricing/PricingContent";

export default function PricingPage() {
  return (
    <div className="p-6 lg:p-8">
      <PricingContent showLayout={false} />
    </div>
  );
}
